// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__2Pq2v","unreadBadge":"styles_unreadBadge__1JKv0","modalContent":"styles_modalContent__jupoj","modal":"styles_modal__1jLfa"};